import React, { useState } from 'react';
import SettingsHeader from 'routes/settings/SettingsHeader';
import { EOrganization, ESnapshotExists } from 'lib/types';
import useAsyncEffect from 'lib/frontend/hooks/useAsyncEffect';
import { getFirebaseContext } from 'utils/firebase';
import { PublisherPaginationSettingsService } from 'lib/services/publisherPaginationSettingsService';
import { LoadingSpinner } from 'lib/components/LoadingSpinner';
import { ColumnButton } from 'lib/components/ColumnButton';
import NoSettingsFound from './NoSettingsFound';
import AutoPaginationTestModal from './AutoPaginationTestModal';
import OrderPaginationSettingsTab from './OrderPaginationSettingsTab';

export default function PaginationSettings({
  activeOrganization
}: {
  activeOrganization: ESnapshotExists<EOrganization>;
}) {
  const {
    value: publisherPaginationSettings,
    isLoading,
    invalidateData
  } = useAsyncEffect({
    fetchData: async () => {
      const [defaultError, defaultSettings] =
        await new PublisherPaginationSettingsService(
          getFirebaseContext()
        ).getDefaultSettings(activeOrganization);
      if (defaultError) {
        return null;
      }
      return defaultSettings;
    },
    dependencies: [activeOrganization?.id]
  });
  const [showTestModal, setShowTestModal] = useState(false);

  return (
    <>
      <SettingsHeader
        header="Pagination"
        description="Control how Column exports notice blocks for your publication."
      >
        {publisherPaginationSettings && (
          <ColumnButton
            buttonText="Test settings"
            onClick={() => setShowTestModal(true)}
            type="button"
            primary
          />
        )}
      </SettingsHeader>

      {publisherPaginationSettings && (
        <div className="mx-auto max-w-4xl p-4">
          {isLoading ? (
            <LoadingSpinner />
          ) : publisherPaginationSettings ? (
            <OrderPaginationSettingsTab
              autoPaginationSettings={publisherPaginationSettings}
            />
          ) : (
            <NoSettingsFound
              organization={activeOrganization}
              onCreate={invalidateData}
            />
          )}
        </div>
      )}
      {showTestModal && publisherPaginationSettings && (
        <AutoPaginationTestModal
          onClose={() => setShowTestModal(false)}
          activeOrganization={activeOrganization}
        />
      )}
    </>
  );
}
